module.exports = __webpack_public_path__ + "img/route-image-black.9982552a.png";